import { IModuleToggles } from "@/Store";

export const moduleForPath = (path: string): keyof IModuleToggles | null => {
  if (path.startsWith("/usuarios")) return "users";
  if (
    path.startsWith("/departamentos") ||
    path.startsWith("/criar-departamento")
  )
    return "departments";
  if (path.startsWith("/leads")) return "leads";
  if (path.startsWith("/clientes") || path.startsWith("/criar-cliente"))
    return "clients";
  if (path.startsWith("/contatos") || path.startsWith("/criar-contato"))
    return "contacts";
  if (path.startsWith("/projetos") || path.startsWith("/criar-projeto"))
    return "projects";
  if (path.startsWith("/assinantes")) return "subscriptions";
  if (path.startsWith("/financeiro") || path.startsWith("/faturas"))
    return "finance";
  if (path.startsWith("/documentos")) return "documents";
  if (path.startsWith("/kanban")) return "kanban";
  return null;
};

export const canAccessModuleRoute = ({
  module,
  userType,
  userModules,
  companyModules,
}: {
  module: keyof IModuleToggles | null;
  userType?: string;
  userModules: string[];
  companyModules?: Partial<IModuleToggles>;
}): boolean => {
  if (!module) return true;
  if (companyModules?.[module] === false) return false;
  if (["superadmin", "owner", "admin", "support"].includes(userType ?? ""))
    return true;
  return userType === "member" && userModules.includes(module);
};
